module.exports = __webpack_public_path__ + "static/carbon-table-basic-aa9b4aec993ec66bdd4b45bfba1f0fc6.png";